import { axios } from "../../../lib/axios";

export const deactiveCard = async (cardId: any) => {
  try {
    const formData = new FormData();
    formData.append("status", "deactivated");
    // Assuming categoryData has other fields you want to append

    const response = await axios.patch(`/cards/${cardId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    // Handle error here
    throw new Error("Error deactivating category: " + error);
  }
};
